import {
    CREATE_PLAY_CHAT_SUCCESS,
    CREATE_PLAY_CHAT_ERROR,
    CREATE_PLAY_CHAT_REQUEST,
    CREATE_PLAY_CHAT_STREAM,
    CREATE_PLAY_CHAT_STOP_LOADER,
} from '../../Types/user/Types';

const initialState = {
    error: '',
    create_play_chat_data: '',
    getStreamingData: false,
    loader: false,
};

export const create_play_chat_Reducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_PLAY_CHAT_SUCCESS:
            return {
                ...initialState.create_play_chat_data,
                error: '',
                create_play_chat_data: action.payload,
                loader: true,
            };
        case CREATE_PLAY_CHAT_ERROR:
            return {
                ...initialState.create_play_chat_data,
                error: action.error,
                create_play_chat_data: '',
                loader: false,
            };
        case CREATE_PLAY_CHAT_REQUEST:
            return {
                ...state,
                error: null,
                create_play_chat_data: action.payload,
                loader: true,
            };
        case CREATE_PLAY_CHAT_STREAM:
            return {
                ...state,
                getStreamingData: action.payload,
                loader: true,
            };
        case CREATE_PLAY_CHAT_STOP_LOADER:
            return {
                ...state,
                getStreamingData: false,
                loader: false,
            };
        default:
            return state;
    }
};
